import styled, { css } from 'styled-components';

function colorStyle({
  $type,
  theme
}) {
  var _theme$message$$type;
  const color = $type ? (_theme$message$$type = theme.message[$type]) === null || _theme$message$$type === void 0 ? void 0 : _theme$message$$type.iconColor : null;
  return color ? css(["color:", ";"], color) : '';
}
const StyledMessageIcon = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-30039089__sc-1djmvfx-0"
})(["font-size:", ";min-width:", ";", ";text-align:center;margin-inline-end:", ";margin-top:", ";"], ({
  $header,
  theme
}) => $header ? theme.message.iconSizeHeader : theme.message.iconSize, ({
  theme
}) => theme.message.iconSizeHeader, colorStyle, ({
  theme
}) => theme.spacing.base, ({
  $header
}) => $header ? '4px' : '0');
StyledMessageIcon.displayName = 'StyledMessageIcon';
var MessageIcon = StyledMessageIcon;

export { MessageIcon as M };
//# sourceMappingURL=MessageIcon-0c1ceec2.js.map
